import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../services/api';
import { estadoChangeMessage, playPedidoStatusSound } from '../utils/pedidoStatusSound';

export function usePedidoStatusAlert({ onNotify, enabled = true } = {}) {
  const estadosRef = useRef(null);
  const [updatesCount, setUpdatesCount] = useState(0);

  const check = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.getPedidos('');
      const list = res.data || [];
      const map = new Map(list.map((p) => [p.id, p.estado]));

      if (estadosRef.current !== null) {
        for (const [id, estado] of map) {
          const prev = estadosRef.current.get(id);
          if (prev && prev !== estado && estado !== 'pendiente') {
            playPedidoStatusSound(estado);
            setUpdatesCount((n) => n + 1);
            const pedido = list.find((p) => p.id === id);
            onNotify?.({
              id,
              numero: pedido?.numero,
              estado,
              message: pedido?.numero
                ? `${estadoChangeMessage(estado)} — ${pedido.numero}`
                : estadoChangeMessage(estado),
            });
          }
        }
      }
      estadosRef.current = map;
    } catch {
      /* ignore */
    }
  }, [onNotify, enabled]);

  useEffect(() => {
    if (!enabled) {
      setUpdatesCount(0);
      return undefined;
    }
    check();
    // SSE dispara oh:invalidate order; el intervalo es red de seguridad (7 tablets).
    const t = setInterval(check, 45000);
    const onInv = (ev) => {
      const domains = ev.detail?.domains || [];
      if (domains.includes('order')) check();
    };
    window.addEventListener('oh:invalidate', onInv);
    return () => {
      clearInterval(t);
      window.removeEventListener('oh:invalidate', onInv);
    };
  }, [check, enabled]);

  const clearUpdates = useCallback(() => setUpdatesCount(0), []);

  return { updatesCount, clearUpdates };
}
